// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"359":"7484400c","767":"44f0a37b"}[chunkId] + ".chunk.js");